var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                },
                [
                  _c("div", { staticClass: "card cardcontents" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _vm._v(" 사업장별 사고건수 그래프(최근5년) "),
                      _c(
                        "div",
                        {
                          staticClass: "card-more card-more-txt",
                          on: {
                            click: function ($event) {
                              return _vm.goPage("/sop/iim/processAccident")
                            },
                          },
                        },
                        [_vm._v("상세보기")]
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _c("apexchart", {
                          ref: "yearOcuurChart",
                          attrs: {
                            height: "615",
                            type: "bar",
                            options: _vm.yearOcuurChart.chartOptions,
                            series: _vm.yearOcuurChart.series,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                },
                [
                  _c("div", { staticClass: "card cardcontents" }, [
                    _c("div", { staticClass: "card-header" }, [
                      _vm._v(" 작업허가서 MAP "),
                      _c(
                        "div",
                        {
                          staticClass: "card-more card-more-txt",
                          on: {
                            click: function ($event) {
                              return _vm.goPage("/sop/swp/safeWorkPermit")
                            },
                          },
                        },
                        [_vm._v("상세보기")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "card-more main-header-input",
                          staticStyle: { width: "140px" },
                        },
                        [
                          _c("c-datepicker", {
                            attrs: { name: "workPermitDate", default: "today" },
                            on: { datachange: _vm.getWorkPermit },
                            model: {
                              value: _vm.workPermit.date,
                              callback: function ($$v) {
                                _vm.$set(_vm.workPermit, "date", $$v)
                              },
                              expression: "workPermit.date",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "card-more main-header-input" },
                        [
                          _vm.workPermit.maps && _vm.workPermit.maps.length > 0
                            ? _c("c-select", {
                                attrs: {
                                  comboItems: _vm.workPermit.maps,
                                  type: "none",
                                  itemText: "mapName",
                                  itemValue: "sopMapId",
                                  name: "sopMapId",
                                  label: "",
                                },
                                on: { datachange: _vm.mapChange },
                                model: {
                                  value: _vm.workPermit.sopMapId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.workPermit, "sopMapId", $$v)
                                  },
                                  expression: "workPermit.sopMapId",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm.workPermit.maps && _vm.workPermit.maps.length > 0
                          ? _c(
                              "q-carousel",
                              {
                                staticClass: "workPermit-carousel",
                                attrs: {
                                  swipeable: "",
                                  animated: "",
                                  arrows: "",
                                  "control-type": "regular",
                                  "control-color": "orange",
                                  infinite: "",
                                },
                                model: {
                                  value: _vm.workPermit.slide,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.workPermit, "slide", $$v)
                                  },
                                  expression: "workPermit.slide",
                                },
                              },
                              _vm._l(_vm.workPermit.maps, function (map, idx) {
                                return _c(
                                  "q-carousel-slide",
                                  {
                                    key: idx,
                                    attrs: { name: idx, "img-src": map.mapSrc },
                                  },
                                  [
                                    _vm._l(map.maps, function (item, idx) {
                                      return _c(
                                        "VueDraggableResizable",
                                        {
                                          key: idx,
                                          ref: "markImage",
                                          refInFor: true,
                                          staticClass: "mainMarkImage",
                                          attrs: {
                                            resizable: false,
                                            parent: true,
                                            draggable: false,
                                            x: item.locationXcoordinate,
                                            y: item.locationYcoordinate,
                                            w: 30,
                                            h: 20,
                                            grid: [30, 20],
                                          },
                                        },
                                        [
                                          _c("q-icon", {
                                            staticClass: "blinking",
                                            attrs: { name: "push_pin" },
                                          }),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "markImage-abbreviation-parent",
                                              style: {
                                                width: !item.isHover
                                                  ? item.resultTypes.length > 3
                                                    ? "227px"
                                                    : _vm.getWidth(item)
                                                  : "241px",
                                                left: _vm.getLeft(item),
                                                top: _vm.getTop(item),
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "markImage-abbreviation",
                                                  on: {
                                                    mouseover: () => {
                                                      item.isHover = true
                                                    },
                                                    mouseleave: () => {
                                                      item.isHover = false
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "transition",
                                                    {
                                                      attrs: {
                                                        name: "mark-list",
                                                        tag: "div",
                                                      },
                                                    },
                                                    [
                                                      !item.isHover
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "markImage-tran",
                                                            },
                                                            [
                                                              _vm._l(
                                                                item.resultTypes.slice(
                                                                  0,
                                                                  3
                                                                ),
                                                                function (
                                                                  resultType,
                                                                  idx
                                                                ) {
                                                                  return _c(
                                                                    "q-banner",
                                                                    {
                                                                      key: idx,
                                                                      class: [
                                                                        "markImage-abbreviation-banner",
                                                                        item
                                                                          .resultTypes
                                                                          .length <
                                                                          4 &&
                                                                        idx ===
                                                                          item
                                                                            .resultTypes
                                                                            .length -
                                                                            1
                                                                          ? "last-banner"
                                                                          : "",
                                                                      ],
                                                                      attrs: {
                                                                        dense:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "q-icon",
                                                                        {
                                                                          staticClass:
                                                                            "text-red",
                                                                          attrs:
                                                                            {
                                                                              name: _vm.workPermitIconName(
                                                                                resultType
                                                                              ),
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                resultType.sopWorkTypeName
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                }
                                                              ),
                                                              item.resultTypes
                                                                .length > 3
                                                                ? _c(
                                                                    "q-banner",
                                                                    {
                                                                      key: "-1",
                                                                      class: [
                                                                        "markImage-abbreviation-plus",
                                                                      ],
                                                                      attrs: {
                                                                        dense:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "q-icon",
                                                                        {
                                                                          staticClass:
                                                                            "text-red",
                                                                          attrs:
                                                                            {
                                                                              name: "add",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                            .resultTypes
                                                                            .length -
                                                                            3
                                                                        ) + " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "q-icon",
                                                                            {
                                                                              staticClass:
                                                                                "text-black",
                                                                              attrs:
                                                                                {
                                                                                  name: "more_horiz",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "transition",
                                                    {
                                                      attrs: {
                                                        name: "mark-list",
                                                        tag: "div",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value:
                                                                item.isHover,
                                                              expression:
                                                                "item.isHover",
                                                            },
                                                          ],
                                                        },
                                                        _vm._l(
                                                          item.resultTypes,
                                                          function (
                                                            resultType,
                                                            idx
                                                          ) {
                                                            return _c(
                                                              "q-banner",
                                                              {
                                                                key: idx,
                                                                class: [
                                                                  idx % 2 === 1
                                                                    ? "bg-grey-3"
                                                                    : "bg-grey-1",
                                                                  "markImage-abbreviation-banner-detail",
                                                                ],
                                                                attrs: {
                                                                  dense: "",
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "avatar",
                                                                        fn: function () {
                                                                          return [
                                                                            _c(
                                                                              "q-icon",
                                                                              {
                                                                                staticClass:
                                                                                  "text-red",
                                                                                attrs:
                                                                                  {
                                                                                    name: _vm.workPermitIconName(
                                                                                      resultType
                                                                                    ),
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        },
                                                                        proxy: true,
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      resultType.sopWorkTypeName
                                                                    ) +
                                                                    " "
                                                                ),
                                                                _c("q-badge", {
                                                                  attrs: {
                                                                    color:
                                                                      _vm.workPermitbadgeColor(
                                                                        resultType.swpStepName
                                                                      ),
                                                                    label:
                                                                      resultType.swpStepName,
                                                                  },
                                                                }),
                                                                _c("q-btn", {
                                                                  staticClass:
                                                                    "q-ml-sm",
                                                                  attrs: {
                                                                    outline: "",
                                                                    round: "",
                                                                    dense: "",
                                                                    color:
                                                                      "red",
                                                                    size: "9px",
                                                                    label: "",
                                                                    icon: "add",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openWorkPermit(
                                                                          resultType
                                                                        )
                                                                      },
                                                                  },
                                                                }),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "caption-work",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          resultType.workSummary
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }),
                                  ],
                                  2
                                )
                              }),
                              1
                            )
                          : _c("el-empty", {
                              attrs: {
                                "image-size": 467,
                                description:
                                  "지도에 등록된 작업허가서가 없습니다.",
                              },
                            }),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
          [
            _c(_vm.impr.component, {
              tag: "component",
              attrs: { isManage: true },
            }),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row topmainrow" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c("div", { staticClass: "topmainlayer card" }, [
            _c("div", { staticClass: "mainCircle" }, [
              _c("div", { staticClass: "circlem" }, [
                _c("div", { staticClass: "circleText circleText1" }, [
                  _c("p", [_vm._v("사고"), _c("br"), _vm._v("Zero")]),
                ]),
                _c("div", { staticClass: "circleTextCenter" }, [
                  _vm._v("- 기본을 준수하는 안전문화 구축"),
                  _c("br"),
                  _vm._v("- 중대재해 예방 관리"),
                ]),
              ]),
              _c("div", { staticClass: "circlem" }, [
                _c("div", { staticClass: "circleText circleText2" }, [
                  _c("p", [_vm._v("시스템"), _c("br"), _vm._v("구축")]),
                ]),
                _c("div", { staticClass: "circleTextCenter" }, [
                  _vm._v("- 법규/규정 준수 및 자율 실천"),
                  _c("br"),
                  _vm._v("- 지속적 안전보건 개선 활동 추구"),
                ]),
              ]),
              _c("div", { staticClass: "circlem" }, [
                _c("div", { staticClass: "circleText circleText3" }, [
                  _c("p", [_vm._v("녹색"), _c("br"), _vm._v("경영")]),
                ]),
                _c("div", { staticClass: "circleTextCenter" }, [
                  _vm._v("- 환경 오염 최소화 및 자원의 재활용 촉진"),
                  _c("br"),
                  _vm._v("- ESG경영 실천 및 목표 달성"),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }